import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'skeleton-pb-contributor-list',
  templateUrl: './skeleton-contributor-list.component.html',
  styleUrls: ['./skeleton-contributor-list.component.css']
})
export class SkeletonContributorListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
